import Component from '@glimmer/component';
import { eq } from 'ember-truth-helpers';
import InboundOutboundRules from 'hcp/components/page/hvn-peerings/detail/content-tabs/azure/code-snippets/consul/inbound-outbound-rules';

export default class SecurityGroupsTerminal extends Component {
  <template>
    {{#if (eq @product @products.consul.id)}}
      {{! Terminal Consul content }}
      <InboundOutboundRules
        @securityGroupId={{@securityGroupId}}
        @model={{@model}}
        @products={{@products}}
      />
    {{/if}}
  </template>
}
